import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import Image from './../Image';
import Container from './../Container';
import css from 'css';

class ImageModule extends Component {

    constructor() {
        super();

        this.state = {

        }
    }

    render() {
        const { data } = this.props;

        //console.log('Image', data);

        return(
            <ModuleWrapper background={data.background}>
                <Container>
                    <Image image={data.image} ratio="16:9" background minHeight="190px" />
                </Container>
            </ModuleWrapper>
        );
    }
}

export default withRouter(ImageModule);

const ModuleWrapper = styled.div`
    background-color: ${props => props.background === 'white' ? '#fff' : css.colors.gray};
`



// WEBPACK FOOTER //
// ./src/partials/modules/Image.js